import { render, staticRenderFns } from "./EditBotGridForm.vue?vue&type=template&id=be17c9be&"
import script from "./EditBotGridForm.vue?vue&type=script&lang=js&"
export * from "./EditBotGridForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports